<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a><a id="page_iii"></a>
<h1 class="title">The Viking Saint</h1>
<p class="author">Olaf II of Norway</p>
<p class="author1">John Carr</p>
<div class="img_container3">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?15469bb4